/**
 * Define types which are possible values for the JavaScript
 * typeof comparator.
 *
 * @type {enum}
 */
export const TYPE_OF = {
    NUMBER: 'number',
    STRING: 'string',
    UNDEFINED: 'undefined'
}
